



































































































































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import utils from '../../../lib/util'
import Query from '../../../components/query/index.vue'
import print from '../../../components/print/bill.vue'
import myTable from '../../../components/table/my-table.vue'
import {GetChargeSumReport} from "../../../api/statistics"
@Component({
  components:{Query,myTable,print}
})
export default class extends AbpBase{
    printShow = false
    columns:any = [
        {
            title: '序号',
            key: 'xh',
            align:'center'
        },
        {
            title: '收入类别',
            key: 'srlb',
            align:'center'
        },
        {
            title: '收入金额',
            children:[
                {
                    title: '本月数',
                    key: 'xytxbyzje',
                    align:'center',
                    render:(h:any,p:any)=> {
                        return h('span',utils.toThousands(Number(p.row.xytxbyzje).toFixed(2)))
                    },  
                },
                {
                    title: '本年累计',
                    key: 'xytxbnlj',
                    align:'center',
                    render:(h:any,p:any)=> {
                        return h('span',utils.toThousands(Number(p.row.xytxbnlj).toFixed(2)))
                    },  
                },
            ]
        },
        {
            title: '应计比例',
            key: 'yjbl',
            align:'center'
        },
        {
            title: '应计金额',
            children:[
                {
                    title: '本月数',
                    key: 'yjjebys',
                    align:'center',
                    render:(h:any,p:any)=> {
                        return h('span',utils.toThousands(Number(p.row.yjjebys).toFixed(2)))
                    },
                },
                {
                    title: '本年累计',
                    key: 'yjjebnlj',
                    align:'center',
                    render:(h:any,p:any)=> {
                        return h('span',utils.toThousands(Number(p.row.yjjebnlj).toFixed(2)))
                    },
                },
            ]
        },
        {
            title: '上药提取比例',
            key: 'sytqbl',
            align:'center'
        },
        {
            title: '上药依升应收金额',
            children:[
                {
                    title: '本月数',
                    key: 'syysbyzje',
                    align:'center',
                    render:(h:any,p:any)=> {
                        return h('span',!p.row.syysbyzje?'':p.row.syysbyzje!='待结算'?utils.toThousands(Number(p.row.syysbyzje).toFixed(2)):p.row.syysbyzje)
                    },
                },
                {
                    title: '本年累计',
                    key: 'syysbnlj',
                    align:'center',
                    render:(h:any,p:any)=> {
                        return h('span',!p.row.syysbnlj?'':p.row.syysbnlj!='待结算'?utils.toThousands(Number(p.row.syysbnlj).toFixed(2)):p.row.syysbnlj)
                    },
                },
            ]
        },
    ]
    colors = ['F4B084','F8CBAD','FCE4D6','2F75B5','9BC2E6','DDEBF7','92D050']


    date = this.formatDate(new Date())
    list = []
    tenantId = null
//     90201	天长金太阳医院血液透析中心
// 90202	南通市肾脏病医院
// 90203	上药依升测试培训中心
// 90204	六安上药依升血液透析中心
// 90205	通州上药依升血液透析中心
    tenantList = [
        {tenantId:90201,name:'天长金太阳医院血液透析中心'},
        {tenantId:90202,name:'南通市肾脏病医院'},
        {tenantId:90203,name:'上药依升测试培训中心'},
        {tenantId:90204,name:'六安上药依升血液透析中心'},
        {tenantId:90205,name:'通州上药依升血液透析中心'}
    ]
    tableRowClassName({row, rowIndex}){
        if (row.xh === '一') {
          return 'color1';
        } else if (row.xh === '二') {
          return 'color2';
        } else if (row.xh[0]=='1'&&row.xh.length == 3) {
          return 'color3';
        } else if (row.xh[0]=='1'&&row.xh.length == 5) {
          return 'color4';
        } else if (row.xh[0]=='2'&&row.xh.length == 3) {
          return row.srlb == '病房收入'?'color7':'color5';
        } else if (row.xh[0]=='2'&&row.xh.length == 5) {
          return 'color6';
        }
        return '';
    }
    created() {
        //动态添加标签（）
        utils.loadScript('./js-xlsx/js/xlsx.extendscript.js')
        utils.loadScript('./js-xlsx/js/xlsx-style/xlsx.full.min.js')
        utils.loadScript('./js-xlsx/js/export.js')
        this.getData()
    }
    async getData(){
        let data = {
            MonthStartTime:this.date.replace(this.date.split('-')[2],'01'), //当月第一天
            MonthEndTime:this.formatDate(new Date(this.date.split('-')[0],this.date.split('-')[1],0)),//当月最后一天
            YearStartTime:this.date.split('-')[0]+'-01-01',//当年第一天
            YearEndTime:this.formatDate(new Date(this.date.split('-')[0],this.date.split('-')[1],0)),//当月最后一天
            tenantId:this.tenantId
        }
        let res = await GetChargeSumReport(data)
        //区分大类 一 和 二 下面的子项
        let tjGroupIndex;
        res.data.forEach((item:any,index:any) => {
            if(item.xh==='2.1'){
                tjGroupIndex = index
            }
        });
        //找出两大类用来合计金额
        let tj1List = res.data.filter((item:any,index:any)=>{return index<tjGroupIndex})
        let tj2List = res.data.filter((item:any,index:any)=>{return index>=tjGroupIndex})
        let xytxbnlj = 0;
        let xytxbyzje = 0;
        let yjjebnlj = 0;
        let yjjebys = 0;
        tj1List.forEach(item => {
            item?item:0
            if(item.xh[0] == '1' && item.xh.length == 3){
                xytxbnlj += Number(item.xytxbnlj);
                xytxbyzje += Number(item.xytxbyzje);
                yjjebnlj += Number(item.yjjebnlj);
                yjjebys += Number(item.yjjebys);
            }
        });
        let tj1Obj = {
            srlb: "直接收入",
            sytqbl: "待结算",
            syysbnlj: "待结算",
            syysbyzje: '待结算',
            xh: "一",
            xytxbnlj:xytxbnlj.toFixed(2) ,
            xytxbyzje: xytxbyzje.toFixed(2),
            yjbl: tj1List[0].yjbl,
            yjjebnlj: yjjebnlj.toFixed(2),
            yjjebys: yjjebys.toFixed(2),
        };
        let xytxbnlj2 = 0;
        let xytxbyzje2 = 0;
        let yjjebnlj2 = 0;
        let yjjebys2 = 0;
        let syysbnlj2 = 0;
        let syysbyzje2 = 0;
        tj2List.forEach(item => {
            item?item:0
            if(item.xh[0] == '2' && item.xh.length == 3 && item.xh!='2.5'){
                xytxbnlj2 += Number(item.xytxbnlj);
                xytxbyzje2 += Number(item.xytxbyzje);
                yjjebnlj2 += Number(item.yjjebnlj);
                yjjebys2 += Number(item.yjjebys);
                syysbnlj2 += Number(item.syysbnlj);
                syysbyzje2 += Number(item.syysbyzje);
            }
        });
        let tj2Obj = {
            srlb: "间接收入",
            sytqbl: tj2List[0].sytqbl,
            syysbnlj: syysbnlj2.toFixed(2),
            syysbyzje: syysbyzje2.toFixed(2),
            xh: "二",
            xytxbnlj:xytxbnlj2.toFixed(2) ,
            xytxbyzje: xytxbyzje2.toFixed(2),
            yjbl: tj2List[0].yjbl,
            yjjebnlj: yjjebnlj2.toFixed(2),
            yjjebys: yjjebys2.toFixed(2),
        };
        this.list = [tj1Obj,...tj1List,tj2Obj,...tj2List]
    }
    downxlsx(){
        var xlsxParam = { raw: true};//转换成excel时，使用原始的格式
        var wb = XLSX2.utils.table_to_sheet(document.querySelector("#mytable"),xlsxParam);//mytable为表格的id名
        const colors = ['F4B084','F8CBAD','FCE4D6','2F75B5','9BC2E6','DDEBF7','92D050','FFFFFF']
        const borderAll = {  //单元格外侧框线
            top: {
                style: 'thin'
            },
            bottom: {
                style: 'thin'
            },
            left: {
                style: 'thin'
            },
            right: {
                style: 'thin'
            }
        };
        //去掉表头隐藏的th(根据表格情况来删除，一般表头会有多余。tr合并几行就删几个)
        delete wb.K1
        delete wb.K2
        //取出最大列
        console.log(wb)
        var cells = [];
        var cellLength = 0;
        for (const i in wb) {
            if(/\d+/.test(i)){
                var str:any =  i;
                str = Number(str.substr(1)); //删除第一个字符
                cellLength = str>cellLength?str:cellLength
                cells.push(i)
            }
        }
        //解决合并单元格后 单元格跳级（如 K1直接到 K5，中间内容会缺失样式，）设置为空
        for(var i = 0; i < cells.length; i++){
            for(var k = 1 ; k < cellLength; k++ ){
                let ksy = String(cells[i][0])+String(k)
                if(!cells.includes(ksy)){
                    wb[ksy] = {
                        s: {
                            border:borderAll
                        },
                        t: "s",
                        v: "",
                    }
                }
            }
        }
        console.log(wb)
        //bgcolor绑定（找出哪些row 需要绑定 记录row标识和当前row所需要的颜色下标）
        var bgcells = []
        for (const i in wb) {
            if(/\d+/.test(i)){
                var colrIndex = 7;
                if (wb[i].v === '一') {
                    bgcells.push({
                        i:i.substr(1,i.length-1),
                        bgi:0,
                    })
                } else if (wb[i].v === '二') {
                    bgcells.push({
                        i:i.substr(1,i.length-1),
                        bgi:3,
                    })
                } else if (wb[i].v.split('.')[0]=='1'&&wb[i].v.length == 3) {
                    bgcells.push({
                        i:i.substr(1,i.length-1),
                        bgi:1,
                    })
                } else if (wb[i].v.split('.')[0]=='1'&&wb[i].v.length == 5) {
                    bgcells.push({
                        i:i.substr(1,i.length-1),
                        bgi:2,
                    })
                } else if (wb[i].v.split('.')[0]=='2'&&wb[i].v.length == 3) {
                    //病房收入特殊处理
                    if(wb[i].v == '2.5'){
                        bgcells.push({
                            i:i.substr(1,i.length-1),
                            bgi:6,
                        })
                    }else{
                        bgcells.push({
                            i:i.substr(1,i.length-1),
                            bgi:4,
                        })
                    }
                } else if (wb[i].v.split('.')[0]=='2'&&wb[i].v.length == 5) {
                    bgcells.push({
                        i:i.substr(1,i.length-1),
                        bgi:5,
                    })
                }
            }
        }
        //赋值字体样式 和背景
        for (const i in wb) {
            if(/\d+/.test(i)){
                wb[i]['s'] = {}
                wb[i]['s'].alignment = {
                    horizontal: "center",
                    vertical: "center",
                    wrapText:true
                }
                wb[i]['s'].border = borderAll;
                wb[i]['s'].fill = {
                    fgColor: {
                        rgb: colors[7]  //背景颜色
                    }
                }
                for(var k = 0 ; k < bgcells.length; k++){
                    if(i.substr(1,i.length-1) == bgcells[k].i){
                        wb[i]['s'].fill = {
                            fgColor: {
                                rgb: colors[bgcells[k].bgi]  //背景颜色
                            }
                        }
                    }
                }
            }
            //表头加粗
            if((i.indexOf('1')===1 || i.indexOf('2')===1 ) && i.length == 2){
                wb[i]['s'].font = {
                    bold: true,
                }
            }
        }
        //列的宽度
        wb["!cols"] = [{
            wpx: 50
        }, {
            wpx: 150
        }, {
            wpx: 100
        }, {
            wpx: 100
        }, {
            wpx: 100
        }, {
            wpx: 100
        }, {
            wpx: 100
        }, {
            wpx: 100
        },{
            wpx: 100
        }, {
            wpx: 100
        }]; 
        //行高，数据条数 map 加上表头 
        wb["!rows"] = [...(this.list.map((item:any)=>{
            return {
                hpx:35,
            }
        })),{hpx:35,},{hpx:35,}]
        let vm = this; 
        //下载方法 （public/js-xlsx/js/export.js）
        openDownloadDialog(sheet2blob([wb]), vm.$route.meta.title+'.xlsx');
        
    }




}
